import { cn } from "@/utils/cnHelper";
import * as React from "react";

type SectionProps = {
  children: React.ReactNode;
  className?: string;
};

export default function Section({ children, className }: SectionProps) {
  return (
    <section className={cn("tw-overflow-hidden tw-py-16 sm:tw-py-16", className)}>
      <div className="tw-mx-auto tw-max-w-7xl tw-px-6 lg:tw-px-8">{children}</div>
    </section>
  );
}
